module.exports = __webpack_public_path__ + "img/dsci0086.3cf9dbbf.jpg";